export const getModularProductSubProduct = (provider, modularProduct) => {
    return (modularProduct?.pricingTable?.byModular?.subProducts ?? []).reduce((acc, subProduct) => {
        const foundProviderSubProduct = provider?.subProducts?.find(({id}) => id === subProduct?.id);
        if (foundProviderSubProduct?.isActive && subProduct.isActive) {
            return [...acc, {...subProduct, ...foundProviderSubProduct, amount: subProduct.defaultAmount ?? 0}];
        }
        return acc;
    }, []);
};
